import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

export class TypeSafeForm<T> {
  formGroup: FormGroup;

  constructor(private fb: FormBuilder, private initial: Partial<T>) {
    this.formGroup = this.createForm({ ...initial } as T);
  }

  get formValue() {
    return this.formGroup.value as T;
  }

  protected createForm(model: T): FormGroup {
    return this.fb.group(model);
  }

  public updateForm(model: Partial<T>): void {
    const nonExisting = Object.keys(model).filter(
      (e) => !!this.formGroup.controls[e]
    );
    if (nonExisting.length) {
      for (const field of nonExisting) {
        this.formGroup.addControl(field, new FormControl(null));
      }
    }
    this.formGroup.patchValue(model);
  }
}
